<button
  tuiButton
  type="button"
  class="tui-space_right-3 tui-space_bottom-3 button_edit_driver"
  size="m"
  appearance="secondary-button"
  *ngIf="showBildButtons"
  (click)="openModaRejectAllBid(templateModalRejectAllBid)"
>{{ "detail_service.pool-manager-bids-tabled-service-details.rejectBidsSingle" | translate }}</button>
<!-- <button
    tuiButton
    type="button"
    class="tui-space_right-3 tui-space_bottom-3 button_edit_driver mr5"
    size="m"
    appearance="primary-button"
    *ngIf="showBildButtons"
    >{{ "detail_service.pool-manager-bids-tabled-service-details.modals.pool-manager-modal-confirm-bid.acceptBid" | translate }}</button> -->
<br /><br />
<table tuiTable size="l" style="width: 100%" [columns]="columns">
  <thead>
    <tr tuiThGroup>
      <th class="th-style" *tuiHead="'check'" tuiTh [sticky]="true">
        <tui-checkbox
          (click)="toggleAll()"
          [(ngModel)]="select_all_bids"
          class="tui-space_bottom-3"
        ></tui-checkbox>
      </th>
      <th [sticky]="true" *tuiHead="'price'" tuiTh>{{ "comercial.clients.detail_client.price" | translate }}</th>
      <th [sticky]="true" *tuiHead="'counterOffer'" tuiTh>{{ "detail_service.pool-manager-bids-tabled-service-details.columns.offerPrice" | translate }}</th>
      <th [sticky]="true" *tuiHead="'margen'" tuiTh>{{ "POOL_PARAMETERS.PRODUCT_HEADERS.3" | translate }}</th>
      <th [sticky]="true" *tuiHead="'driver'" tuiTh>{{ "detail_service.pool-manager-bids-tabled-service-details.columns.completeDriverName" | translate }}</th>
      <th [sticky]="true" *tuiHead="'date'" tuiTh>{{ "sweeper_car.sweeper-car-node-detail.node-event.column.date" | translate }}</th>
      <th [sticky]="true" *tuiHead="'hour'" tuiTh>Hora reco</th>
      <th [sticky]="true" *tuiHead="'status'" tuiTh>{{ "comercial.clients.column.isEnabled" | translate }}</th>
      <th [sticky]="true" *tuiHead="'actions'" tuiTh>{{ "comercial.prices.tableHeaderActions" | translate }}</th>
    </tr>
  </thead>
  <tbody tuiTbody>
    <tr tuiTr *ngFor="let da of pooldata; let i = index">
      <td *tuiCell="'check'" tuiTd>
        <div [tuiCell]="size">
          <tui-checkbox
            [(ngModel)]="selectedMap[i]"
            (ngModelChange)="toggleSelection(i)"
            class="tui-space_bottom-3 ml-25"
          ></tui-checkbox>
        </div>
      </td>
      <td *tuiCell="'price'" tuiTd>
        <div [tuiCell]="size">
          <span tuiTitle> {{ da.price }}€ </span>
        </div>
      </td>
      <td *tuiCell="'counterOffer'" tuiTd>
        <div [tuiCell]="size">
          <span tuiTitle> {{ da.counterOffer }}€ </span>
        </div>
      </td>
      <td *tuiCell="'margen'" tuiTd>
        <div [tuiCell]="size">
          <span tuiTitle> {{ da.margen }}% </span>
        </div>
      </td>
      <td *tuiCell="'driver'" tuiTd>
        <div [tuiCell]="size">
          <span tuiTitle>
            {{ da.driver }}
          </span>
        </div>
      </td>
      <td *tuiCell="'date'" tuiTd>
        <div [tuiCell]="size">
          <span tuiTitle>
            {{ da.date }}
          </span>
        </div>
      </td>
      <td *tuiCell="'hour'" tuiTd>
        <div [tuiCell]="size">
          <span tuiTitle>
            {{ da.hour }}
          </span>
        </div>
      </td>
      <td *tuiCell="'status'" tuiTd>
        <div [tuiCell]="size">
          <span tuiTitle *ngIf="da.status == 'pending'">
            <span tuiStatus="var(--tui-warning-fill)">{{ "Pendiente" | translate }}</span>
          </span>
          <span tuiTitle *ngIf="da.status == 'accepted'">
            <span tuiStatus="var(--tui-success-fill)">{{ "detail_service.pool-manager-bids-tabled-service-details.statusLabels.BID_ACCEPTED" | translate }}</span>
          </span>
          <span tuiTitle *ngIf="da.status == 'rejected'">
            <span tuiStatus="var(--tui-error-fill)">{{ "detail_service.pool-manager-bids-tabled-service-details.statusLabels.BID_REJECTED" | translate }}</span>
          </span>
        </div>
      </td>
      <td *tuiCell="'actions'" tuiTd>
        <div [tuiCell]="size">
          <button (click)="toggleDropdown(i)" class="button_bids">
            <tui-icon icon="tuiIconEdit2" class="icon_menu_edit"></tui-icon>
          </button>
          <div class="custom-dropdown" *ngIf="openedDropdownId === i">
            <button
              class="dropdown-item"
              (click)="openModaAceptBid(templateModalAceptBid, da.driver)"
            >
              <tui-icon
                icon="tuiIconUserCheck"
                class="icon_menu_edit"
              ></tui-icon>{{ "detail_service.pool-manager-bids-tabled-service-details.modals.pool-manager-modal-confirm-bid.acceptBid" | translate }}</button>
            <button
              class="dropdown-item reject"
              (click)="openModaRejectBid(templateModalRejectBid, da.driver)"
            >
              <tui-icon icon="tuiIconXSquare" class="icon_menu_edit"></tui-icon>{{ "detail_service.pool-manager-bids-tabled-service-details.rejectBidsSingle" | translate }}</button>
          </div>
        </div>
      </td>
    </tr>
  </tbody>
</table>
<ng-template #templateModalAceptBid>
  <div class="modal-body">
    <div class="content_cancel_service">
      <br />
      <p class="fs_24">{{ "detail_service.pool-manager-bids-tabled-service-details.modals.pool-manager-modal-confirm-bid.acceptBid" | translate }}</p>
      <p class="fs_13">{{ "detail_service.pool-manager-bids-tabled-service-details.modals.pool-manager-modal-confirm-bid.acceptBidWarning" | translate }}</p>
    </div>
    <div class="right_buttons">
      <button class="close_modal_logout" (click)="modalRef?.hide()">{{ "comercial.clients.detail_client.modal_exit_without_save" | translate }}</button>
      <button class="add_topping_but" (click)="aceptBild()">{{ "USER_NAVBAR.7" | translate }}</button>
      <br />
      <br />
      <div class="div_loader_modal div_inside_acept_bid">
        <img
          src="assets/logo-loading.gif"
          class="img_loader_inside_modal"
          alt=""
        />
      </div>
    </div>
  </div>
</ng-template>
<ng-template #templateModalRejectBid>
  <div class="modal-body">
    <div class="content_cancel_service">
      <br />
      <p class="fs_24">{{ "detail_service.pool-manager-bids-tabled-service-details.rejectBidsSingle" | translate }}</p>
      <p class="fs_13">
        Al rechazar esta puja, se quitara de la lista de pujas.
      </p>
    </div>
    <div class="right_buttons">
      <button class="close_modal_logout" (click)="modalRef?.hide()">{{ "comercial.clients.detail_client.modal_exit_without_save" | translate }}</button>
      <button class="add_topping_but" (click)="rejectBild()">{{ "USER_NAVBAR.7" | translate }}</button>
      <br />
      <br />
      <div class="div_loader_modal div_inside_acept_bid">
        <img
          src="assets/logo-loading.gif"
          class="img_loader_inside_modal"
          alt=""
        />
      </div>
    </div>
  </div>
</ng-template>
<ng-template #templateModalRejectAllBid>
  <div class="modal-body">
    <div class="content_cancel_service">
      <br />
      <p class="fs_24">{{ "detail_service.pool-manager-bids-tabled-service-details.modals.pool-manager-modal-reject-bid.rejectAllBids" | translate }}</p>
      <p class="fs_13">
        Se rechazarán todas las ofertas activas y el servicio quedará sin pujas
        pendientes.
      </p>
    </div>
    <div class="right_buttons">
      <!-- <button class="close_modal_logout" (click)="modalRef?.hide()">{{ "comercial.clients.detail_client.modal_exit_without_save" | translate }}</button> -->
      <button class="add_topping_but" (click)="rejectAllBild()">{{ "common.actions.confirm" | translate }}</button>
      <br />
      <br />
      <div class="div_loader_modal div_inside_acept_bid">
        <img
          src="assets/logo-loading.gif"
          class="img_loader_inside_modal"
          alt=""
        />
      </div>
    </div>
  </div>
</ng-template>
